import React from 'react'
import { getImages } from '../const';

const InventorySmItem = ({car, index}) => {
  return (
    <>
        <div className='col-md-4 animated zoomIn'
                style={{
                    visibility: 'visible',
                    animationDelay: '0.2s',
                    animationName: 'zoomIn'
                }}
                key={index}
            >
                <article className="srp-box">
                    <div className="srp-top">
                        <img src={getImages(car.image)}/>
                    </div>
                    <div className="srp-bottom">
                        <div className="sm-title text-orange font-bold">{car.title}</div>
                        <div className="d-flex align-items-center justify-content-between">
                            <div className="sm-title">{car.price}</div>
                            <div className="sm-title opacity-0-4">{car.mileage}</div>
                        </div>
                        <div className="d-flex align-items-center justify-content-between srpb-hover">
                            <div className="sm-title">Stock #</div>
                            <div className="sm-title">012023182348</div>
                        </div>
                        <div className="d-flex align-items-center justify-content-between srpb-hover">
                            <div className="sm-title">VIN</div>
                            <div className="sm-title">ABC123456789012</div>
                        </div>
                        <div className="d-flex align-items-center justify-content-between srpb-hover">
                            <div className="sm-title">Interior Color</div>
                            <div className="sm-title">Black</div>
                        </div>
                        <div className="d-flex align-items-center justify-content-between srpb-hover">
                            <div className="sm-title">Exterior Color</div>
                            <div className="sm-title">White</div>
                        </div>
                        <div className='d-flex align-items-center justify-content-between mt-3'>
                            <div className='btn-window-sticker text-orange'><img className='me-2' src={getImages('window-icon.webp')}/> Window Sticker</div>
                            <div>
                                <a href='#' className='btn-white-theme d-inline-block'>Vehicle Details</a>
                            </div>
                        </div>
                    </div>
                </article>
            </div>
    </>
  )
}

export default InventorySmItem